<template>
  <a
    title="Get Directions"
    target="_blank"
    :href="href"
  >
    <span class="cf-icon cf-icon--bigger far a-map-marker" />

    <slot />
  </a>
</template>


<script>
  export default {
    name: 'DirectionsButton',

    props: {
      location: {
        type: Object,
        required: true
      }
    },

    computed: {
      href() {
        const { address } = this.location;
        const query = [
          address.line1,
          address.city,
          address.state,
          address.postalCode
        ].join(', ');

        return address.mapsUrlOverride || `https://www.google.com/maps/dir/?api=1&destination=${query}`;
      }
    }
  };
</script>
